/**
 * How often Horizon refetches GET /maintenance/status.
 * Change these two values to retune polling.
 */
export const MAINTENANCE_POLL_INTERVAL = {
  /** Maintenance is off. */
  offMs: 5 * 60 * 1000,
  /** Maintenance is on. */
  onMs: 10 * 1000
} as const

type PollSnapshot = {
  enabled: boolean
  scheduledStartAt?: string | null
  scheduledEndAt?: string | null
}

function parseTime(value?: string | null): number | null {
  if (!value) return null
  const ms = new Date(value).getTime()
  return Number.isNaN(ms) ? null : ms
}

/** True while the flag is on, or a scheduled window has started and not ended. */
export function isMaintenancePollFast(status: PollSnapshot, now = Date.now()): boolean {
  if (status.enabled) return true
  const start = parseTime(status.scheduledStartAt)
  const end = parseTime(status.scheduledEndAt)
  if (start == null || start > now) return false
  if (end != null && end <= now) return false
  return true
}

/**
 * Wait until a scheduled start or end that arrives sooner than the current poll,
 * so a 5-minute interval does not miss a window that begins in a minute or two.
 */
export function nextMaintenanceBoundaryDelay(status: PollSnapshot, now = Date.now()): number | null {
  const fast = isMaintenancePollFast(status, now)
  const target = fast ? parseTime(status.scheduledEndAt) : parseTime(status.scheduledStartAt)
  if (target == null || target <= now) return null
  const delay = target - now
  const period = fast ? MAINTENANCE_POLL_INTERVAL.onMs : MAINTENANCE_POLL_INTERVAL.offMs
  if (delay >= period) return null
  return delay
}
